module.exports = __webpack_public_path__ + "img/智能档案柜.b1d07036.jpg";